import jquery from '../../node_modules/jquery';
import '../../node_modules/jquery-migrate';

 window.jQuery = window.$ = jquery;